import styled from 'styled-components'

export const Wrapper = styled.div`
    display:none;
    height:30px;
    margin-bottom:28px; 

    &:hover{
        cursor:pointer;
    }

    @media screen and (max-width:960px){
        display:flex;
    }
`;

export const Icon = styled.div`
    display:flex;
    width:28px;
    height:28px;
    color:${props=>props.theme.colors.primary};
`;

export const Title = styled.h2`
    font-size:24px;
    margin-left:12px;
    margin-top:4px;
    color:${props=>props.theme.colors.primaryDark2};
`;